import { secureApiGet } from '../secureHttp';

export interface MonthBucket {
  month: string;
  value: number;
}

export interface DistributionItem {
  name: string;
  value: number;
}

export interface PsychologistMetrics {
  active_processes: number;
  inactive_processes: number;
  inactive_this_month: number;
  active_to_inactive_pct: number;
  process_limit: number;
  adherence_pct: number;
  sessions_next_7_days: number;
  new_processes_30d: number;
  new_processes_90d: number;
  sessions_this_month: number;
  sessions_total: number;
  cancelled_pct_this_month: number;
  rescheduled_pct_this_month: number;
  avg_sessions_per_process: number;
  avg_days_between_sessions: number;
  retention_6m_pct: number;
  derivations_by_patient: number;
  derivations_requested: number;
  derivations_this_month: number;
  soon_to_start_scheduled: number;
  soon_to_start_paid: number;
  committed_process_count: number;
  monthly_sessions: MonthBucket[];
  monthly_cancelled_pct: MonthBucket[];
  monthly_rescheduled_pct: MonthBucket[];
  monthly_new_processes: MonthBucket[];
  monthly_inactive_processes: MonthBucket[];
  monthly_derivations: MonthBucket[];
  activity_by_sessions: { sesiones: number; value: number }[];
  distribution_by_type: DistributionItem[];
}

export async function getPsychologistMetrics(): Promise<PsychologistMetrics> {
  return secureApiGet<PsychologistMetrics>('/v1/psi-platform/psychologist/metrics');
}
